"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = clearProcedureResult;

var _duck = require("../duck");

var _config = _interopRequireDefault(require("../config"));

var _selectors = require("../duck/selectors");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Copyright 2019 American Express Travel Related Services Company, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express
 * or implied. See the License for the specific language governing
 * permissions and limitations under the License.
 */
function clearProcedureResult(_ref) {
  var procedureName = _ref.procedureName,
      args = _ref.args;
  return function thunk(dispatch, getState) {
    var _config$getProcedure = _config.default.getProcedure(procedureName),
        buildUpdatedCache = _config$getProcedure.buildUpdatedCache;

    var cache = (0, _selectors.getProcedureCache)({
      procedureName: procedureName
    })(getState);
    var updatedCache = buildUpdatedCache({
      cache: cache,
      args: args,
      result: undefined,
      error: undefined
    });
    return dispatch((0, _duck.updateProcedureCache)({
      procedureName: procedureName,
      updatedCache: updatedCache
    }));
  };
}